<template>
  <div class="bsn" id="Business">
    <p class="title" name="Business">业务内容</p>
    <div class="main">
      <el-row :gutter="30">
        <el-col :sm="12" :xs="24">
          <div class="bsn-text">
            <div class="bsn-img">
              <img width="100%" src="@images/bsn_1.png" />
            </div>
            <h4 class="bsn-sub-title">Demand & DSPs</h4>
            <p class="descript">We have 50+ advertisers and 20+ DSPs</p>
          </div>
        </el-col>
        <el-col :sm="12" :xs="24" >
          <div class="bsn-text">
            <div class="bsn-img">
              <img width="100%" src="@images/bsn_2.png" />
            </div>
            <h4 class="bsn-sub-title">Direct Publishers</h4>
            <p class="descript">100+ exclusive App developers with premium in-app traffic</p>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :sm="12" :xs="24" >
          <div class="bsn-text">
            <div class="bsn-img">
              <img width="100%" src="@images/bsn_3.png" />
            </div>
            <h4 class="bsn-sub-title">SSPs</h4>
            <p class="descript">RTB Exchange<br/>Programmatic Direct Buying<br/>Private Auction<br/>Preferred Deal</p>
          </div>
        </el-col>
        <el-col :sm="12" :xs="24" >
          <div class="bsn-text">
            <div class="bsn-img">
              <img width="100%" src="@images/bsn_4.png" />
            </div>
            <h4 class="bsn-sub-title">SDK & JSTag</h4>
            <p class="descript">A self-owned mobile Ad SDK,Max Jstag,ironSource Tag,Topon Adaptor,TradPlus Adaptor,Admob Adaptor</p>
          </div>
        </el-col>
      </el-row>
      <div class="req">
        <h2 class="sub-title">每天100亿+的广告请求！</h2>
        <el-row :gutter="30">
          <el-col :sm="15" :xs="24">
            <img width="100%" src="@images/bsn_5.png" alt="">
          </el-col>
          <el-col :sm="9" :xs="24">
            <img width="100%" src="@images/bsn_6.png" alt="">
          </el-col>
        </el-row>
      </div>
      <div class="stl">
        <h2 class="sub-title">我们支持各种标准的广告格式！</h2>
        <el-row>
          <el-col :sm="12" :xs="24">
            <div class="stl-ele">Native Ads</div>
          </el-col>
          <el-col :sm="12" :xs="24">
            <div class="stl-ele">Banner</div>
          </el-col>
          <el-col :sm="12" :xs="24">
            <div class="stl-ele">Splash</div>
          </el-col>
          <el-col :sm="12" :xs="24">
            <div class="stl-ele">Rich Banner</div>
          </el-col>
          <el-col :sm="12" :xs="24">
            <div class="stl-ele">CTV Video</div>
          </el-col>
          <el-col :sm="12" :xs="24">
            <div class="stl-ele">Interstitial Video</div>
          </el-col>
        </el-row>
      </div>
      <div class="tcf">
        <h2 class="sub-title">支持TCF v2.0</h2>
        <div class="tcf-top-imgs">
          <img v-for="(item, index) in Array(4)" :key="index" :src="require(`@images/tcf_${index+1}.png`)" alt="">
        </div>
        <el-row>
          <el-col :sm="7" :xs="24">
            <img v-for="(item, index) in Array(3)" :key="index" :src="require(`@images/tcf_${index+5}.png`)" alt="">
          </el-col>
          <el-col :sm="17" :xs="24">
            <p class="tcp-content">全面支持TCF V2.0， Transparency and Consent Framework (TCF) v2.0。全面支持IAB标准，保证品牌广告主在一个透明的、纯正的流量体系采购。我们自建的反作弊技术，杜绝了虚假流量的存在。</p>
          </el-col>
        </el-row>
      </div>
      <div class="alg">
        <h2 class="sub-title">AI算法驱动！</h2>
        <el-row>
          <el-col :sm="7" :xs="24" class="alg-left">
            <img src="@images/alg_1.png" alt="">
          </el-col>
          <el-col :sm="17" :xs="24" class="alg-right">
            <div class="alg-c">
              <span class="alg-c-title">深度算法</span>
              <span class="alg-c-content">我们的技术引擎在每次出价之前都会做广告预测，利用推理模型让你在每一个展示中获取最低的价格。</span>
            </div>
            <div class="alg-c">
              <span class="alg-c-title">人群定向</span>
              <span class="alg-c-content">我们利用多维度标签体系：应用类型、游戏题材、游戏画风、用户行为、媒体倾向等，再结合机器学习预测，构建了精准的人群定向功能。</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Business",
  data: function () {
    return {
    };
  }
};
</script>
<style lang="scss" scoped>
.bsn {
  background: #ffffff;
  position: relative;
  box-shadow: $section-box-shadow;
  .main {
    max-width: px2rem(1000);
    margin: 0 auto;
    margin-top: px2rem(20);
    .bsn-sub-title {
      color: $--color-primary;
      font-size: px2rem(25);
      font-family: "Helvetica Neue",sans-serif;
      margin: px2rem(20) 0 px2rem(15) 0;
    }
    .el-row {
      margin: px2rem(0) px2rem(0);
      .el-col {
        margin: px2rem(40) auto;
        .bsn-text{
          height: 100%;
          text-align: center;
          // width: 50%;
          max-width: px2rem(350);
          margin: 0 auto;
          .descript {
            font-size: px2rem(16);
            letter-spacing: 1px;
            line-height: 1.3em;
            margin: 0 auto;
            margin-top: px2rem(-5);
            color: #777;
          }
          .bsn-img {
            width: 90%;
            height: px2rem(180);
            margin: 0 auto;
            overflow: hidden;
            border: 0px solid rgba(0, 0, 0, 0.2);
            border-radius: 8px;
            box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.1);
            padding: px2rem(10);
            box-sizing: border-box;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }
    }
    .req {
      margin-top: px2rem(70);
    }
    .stl {
      margin-top: px2rem(70);
      background: url("~@images/bsn_8.png") no-repeat center top px2rem(100);
      background-size: auto 70%;
      min-height: px2rem(600);
      .stl-ele {
        background: url("~@images/bsn_7.png") no-repeat center;
        background-size: auto 100%;
        width: px2rem(200);
        height: px2rem(80);
        line-height: px2rem(80);
        font-size: px2rem(18);
        // margin-left: px2rem(150);
      }
      .el-row {
        margin-top: px2rem(30);
        & .el-col:nth-child(1) .stl-ele{
          margin-left: px2rem(170);
        }
        & .el-col:nth-child(2) .stl-ele{
          margin-left: px2rem(140);
        }
        & .el-col:nth-child(3) .stl-ele{
          margin-left: px2rem(100);
        }
        & .el-col:nth-child(4) .stl-ele{
          margin-left: px2rem(210);
        }
        & .el-col:nth-child(5) .stl-ele{
          margin-left: px2rem(170);
        }
        & .el-col:nth-child(6) .stl-ele{
          margin-left: px2rem(140);
        }
      }
    }
    .tcf {
      margin-top: px2rem(70);
      .tcf-top-imgs {
        text-align: right;
        border-bottom: 1px solid $--color-primary;
        padding-bottom: px2rem(20);
        img {
          width: 110px;
        }
      }
      .el-row {
        img {
          margin: px2rem(10) 0;
          width: px2rem(200);
          &:nth-child(1) {
            width: px2rem(100);
          }
        }
        .tcp-content {
          text-align: left;
          font-size: px2rem(18.5);
          color: #888888;
          padding: 0 px2rem(20);
          margin-top: px2rem(50);
          line-height: 1.5;
        }
      }
    }
    .alg {
      margin-top: px2rem(70);
      .alg-left {
        text-align: center;
        img {
          width: px2rem(350);
          margin-top: px2rem(-20);
        }
      }
      .alg-right {
        font-size: px2rem(19);
        padding: 0 px2rem(20) 0 px2rem(50);
        span {
          vertical-align: top;
        }
        .alg-c {
          margin-bottom: px2rem(50);
          .alg-c-title {
            background: $--color-primary;
            width: px2rem(110);
            height: px2rem(75);
            display: inline-block;
            text-align: center;
            color: #ffffff;
            line-height: px2rem(75);
            border-radius: 5px;
          }
          .alg-c-content {
            line-height: 1.3;
            display: inline-block;
            width: px2rem(400);
            text-align: left;
            margin-left: px2rem(40);
          }
        }
      }
    }
  }
}
</style>